import React from "react";

import { useParams } from "react-router-dom";
import userService from "../services/userService";

function withParams() {
    return (props) => <ActiveRegister {...props} params={useParams()} />;
}

class ActiveRegister extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            userActive: "N",
        };
    }

    async componentDidMount() {
        try {
            await this.esperar(2000);

            userService
                .activateUser(this.props.params.id)
                .then((e) => this.setState({ userActive: "Y" }))
                .catch((e) => {
                    this.setState({ userActive: "E" });
                });
        } catch (err) {
            if (err.response) {
                console.log("status", err.response.status);
                console.log("headers", err.response.headers);
                console.log("data", err.response.data); // <- aqui normalmente vem a dica do que faltou
            } else {
                console.log("message", err.message);
            }
        }
    }

    esperar(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }

    render() {
        return (
            <>
                <div className="app-login">
                    <form style={{ textAlign: "center" }}>
                        <img src={require("../img/Grupo10.png")} />
                        <br />
                        {this.state.userActive === "N" && (
                            <>
                                <img
                                    src={require("../img/spinner.gif")}
                                    style={{ width: "200px" }}
                                />
                                <br />
                                Aguarde, ativando Usuário...
                            </>
                        )}
                        {this.state.userActive === "Y" && (
                            <>
                                <br />
                                USUÁRIO ATIVADO COM SUCESSO.
                                <br />
                                <br />
                                <button
                                    type="button"
                                    style={{
                                        width: "80%",
                                        padding: "15px",
                                        fontSize: "20px",
                                        color: "#ffffff",
                                        backgroundColor: "var(--unnamed-color-411172)",
                                        borderRadius: "30px",
                                    }}
                                    onClick={() => (window.location.href = "/login")}
                                >
                                    ENTRAR
                                </button>
                            </>
                        )}
                        {this.state.userActive === "E" && (
                            <>
                                <br />
                                FALHA AO ATIVAR O USUÁRIO.
                                <br />
                                ENTRE EM CONTATO COM O NOSSO SUPORTE.
                            </>
                        )}
                    </form>
                </div>
            </>
        );
    }
}

export default withParams();
